/* global globalThis */
import React from "react";
import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import "./Sidebar.css";
import { FaCode,FaQuestionCircle } from "react-icons/fa";
import {
  DashboardIcon,
  DataSourceIcon,
} from "../../assets/icon/svgIcons";
import MyLogo from "../../assets/chatbot.png";

const Sidebar = ({ isOpen }) => {
  const location = useLocation(); // Get current path to highlight active tab

  const { Dashboard, DataSource } =
    JSON.parse(sessionStorage.getItem("rolesAndPermission") || "{}");

  return (
    <>
      {!isOpen && (
        <div className="sidebar closed">
          <ul className={`sidebar-menu ${isOpen ? "" : "margin-closed"}`}>
            {Dashboard?.canView && (
              <li
                className={location.pathname === "/dashboard" ? "active" : ""}
              >
                <Link
                  className={`flex ${
                    isOpen ? "flex-row" : "flex-col"
                  } sidebar-dashboard-joyride-class`}
                  to="/dashboard"
                  title="Dashboard"
                >
                  <DashboardIcon />
                  <div className="sidebar-label">Dashboard</div>
                </Link>
              </li>
            )}
            {DataSource?.canView && (
              <li
                className={
                  location.pathname.includes("/data-sources") ? "active" : ""
                }
              >
                <Link
                  className={`flex ${isOpen ? "flex-row" : "flex-col"} sidebar-datasource-joyride-class`}
                  to="/data-sources"
                  title="Data Sources"
                >
                  <DataSourceIcon />
                  <div className="sidebar-label">Data Sources</div>
                </Link>
              </li>
            )}
                    <li className={location.pathname.includes("/code-gen") ? "active" : ""}>
         <Link
                className={`flex ${isOpen ? "flex-row" : "flex-col"} sidebar-ai-joyride-class`}
                to="/code-gen"
                title="Bluegecko AI"
              >
                <img
                  src={MyLogo}
                  alt="My Logo"
                  className="menu-icon w-6 h-6" // adjust size as needed
                />
                <div className="sidebar-label">BlueGecko AI</div>
              </Link>
        </li>
            <li className={location.pathname.includes("/scriptly") ? "active" : ""}>
              <Link
                className={`flex ${isOpen ? "flex-row" : "flex-col"}`}
                to="/scriptly"
                title="Scriptly"
                onClick={() => {
                  // Dispatch custom event to trigger filter reset in GenerateScript
                  globalThis.dispatchEvent(new CustomEvent('scriptlySidebarClick'));
                }}
              >
                <FaCode className="menu-icon" />
                <div className="sidebar-label">Scriptly</div>
              </Link>
            </li>
            {}
            <li className={location.pathname.includes("/help") ? "active" : ""}>
          <Link
            className="flex flex-col items-center"
            to="/help"
            title="Help"
          >
            <FaQuestionCircle className="menu-icon" />
            <div className="sidebar-label">Help</div>
          </Link>
        </li>

            {}
          </ul>
        </div>
      )}
    </>
  );
};

Sidebar.propTypes = {
  isOpen: PropTypes.bool,
};

export default Sidebar;
